import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import './index.css';
import App from './App';

// 🚫 DISABLE SERVICE WORKER - Prevent caching issues
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
        console.log('✅ Service Worker unregistered - No caching issues!');
      });
    });
  });
}

// Clear all caches on load
window.addEventListener('load', () => {
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
        console.log(`✅ Cache deleted: ${name}`);
      });
    });
  }
});

// Suppress ResizeObserver errors (common with Framer Motion)
const resizeObserverErrorHandler = (e) => {
  if (e.message.includes('ResizeObserver')) {
    e.preventDefault();
    return;
  }
  throw e;
};

window.addEventListener('error', resizeObserverErrorHandler);
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('ResizeObserver')) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<HelmetProvider>
    <App />
  </HelmetProvider>);
